import React from 'react'
import { useRouter } from 'next/router'
import { Button } from 'rsuite'
import useTranslation from '@/hooks/useTranslation'
import styles from './publicationNotFound.module.scss'

const PublicationNotFound = () => {
  const t = useTranslation()
  const router = useRouter()

  const handleGoHome = () => {
    router.push('/')
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.title}>{t('404', '404')}</h1>
        <p className={styles.message}>{t('finding_vehicle_publications_no_pubs', 'Publication not found')}</p>
        <Button appearance="primary" size="lg" onClick={handleGoHome} className={styles.button}>
          {t('select_vehicle', 'Select Vehicle')}
        </Button>
      </div>
    </div>
  )
}

export default PublicationNotFound
